import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HomeNav, { useLanguageContext } from "../navigations/homenav";
import Footer from "../navigations/Footer";

export default function Login({ onLogin }) {
  const { t } = useLanguageContext();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("https://aaapd.org.et/gallery_backend/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      setLoading(false);

      if (data.status === "success") {
        const user = data.user;

        // store in localStorage
        localStorage.setItem("currentUser", JSON.stringify(user));

        // callback for parent
        if (onLogin) onLogin(user);

        // role-based redirect
        if (user.role === "admin") {
          navigate("/admindashboard");
        } else {
          navigate("/dashboard");
        }
      } else {
        setError(data.message || t('loginFailed'));
      }
    } catch (err) {
      setLoading(false);
      setError(t('networkOrServerError'));
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <HomeNav />

      <div className="flex flex-1 items-center justify-center px-4">
        <div className="w-full max-w-md bg-white rounded-xl shadow-lg border border-gray-200 p-8 my-8">
          <h2 className="text-3xl font-bold text-center mb-6 text-gray-800">{t('loginTitle')}</h2>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">{t('emailLabel')}</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="block w-full rounded-md border-gray-300 px-3 py-2 shadow-sm focus:ring-2 focus:ring-teal-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">{t('passwordLabel')}</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="block w-full rounded-md border-gray-300 px-3 py-2 shadow-sm focus:ring-2 focus:ring-teal-500"
              />
            </div>

            <div className="flex items-center justify-between">
              <label className="flex items-center text-sm text-gray-600">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                  className="mr-2 h-4 w-4 text-teal-600"
                />
                {t('rememberMe')}
              </label>
              <button
                type="button"
                onClick={() => navigate("/forgot-password")}
                className="text-sm text-teal-600 hover:underline"
              >
                {t('forgotPassword')}
              </button>
            </div>

            {error && (
              <div className="text-red-600 text-center text-sm font-medium p-2 bg-red-50 rounded-md">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className={`w-full py-2.5 px-4 ${
                loading ? "bg-teal-300" : "bg-teal-500 hover:bg-teal-600"
              } text-white font-semibold rounded-md shadow-md focus:ring-2 focus:ring-teal-500`}
            >
              {loading ? t('loggingIn') : t('loginButton')}
            </button>
          </form>
        </div>
      </div>

      <Footer />
    </div>
  );
}
